export const getStaticAssetURL = () => process.env.REACT_APP_STATIC_STORAGE_URL;

export const buildStaticURL = (relativePath: any) =>
  `${getStaticAssetURL()}/${relativePath}`;
